import "../styles/bidding-list-item.scss";
import { getTimeDiff, fileExist } from "../shared/utils";
import { isMobile } from 'react-device-detect';
import ImageWithDefault from "./ImageWithDefault";
import { CountdownTimer } from "./CountdownTimer";

export const BiddingListItem = (props) => {
    const { data, status } = props;

    const carTitle = data?.countAdditionalCars > 0
        ? `Автомобильное комбо! ${data?.countAdditionalCars + 1} АВТО ПО ЦЕНЕ 1`
        : data?.car?.model?.name;

    return (
        <div key={data?.id} className={isMobile ? "bidding-list-item__mobile" : "bidding-list-item"} {...props}>
            {
                isMobile
                    ? (
                        <div className="bidding-list-item__image-container__mobile">
                            <ImageWithDefault src={data?.fileName} />
                        </div>)
                    : <div className="bidding-list-item__image-container">
                        <ImageWithDefault src={data?.fileName} className={!isMobile ? "bidding-list-item__image" : ""} />
                    </div>
            }
            <div>
                <h3>Лот № {data?.id}. {carTitle}</h3>
                <p>г. {data?.city?.name}</p>
                <p>Продолжительность: {data?.duration}</p>
                {status === "active" ? <CountdownTimer endTime={data.dateEndBidding} /> : "Время вышло!"}
                <p>Начальная цена: {data?.startPrice?.toLocaleString('ru-RU')} ₽</p>
                <p><b>{data?.endPrice != null ? data?.endPrice?.toLocaleString('ru-RU') : data?.startPrice?.toLocaleString('ru-RU')} ₽</b></p>
            </div>

        </div>
    )
}